import { Application, PostApplicationFields } from '@/shared/models/applicationModel'
import { Company } from '@/shared/models/companyModel'
import { RequestResponse, requestService } from '@/shared/services/requestServices'
import { resolveApiUrl } from '@/shared/utils/requestsUtils'
import { trackEvent } from '@/shared/utils/analyticsUtils'

export const getApplicationsService = (
    companyId: Company['id']
): Promise<RequestResponse<Application[]> | undefined> => {
    const url = resolveApiUrl('application.getAll', { variables: { companyId } })
    return requestService<Application[]>(url)
}

export const createApplicationService = async (
    companyId: Company['id'],
    payload: PostApplicationFields
): Promise<RequestResponse<Application> | undefined> => {
    const url = resolveApiUrl('application.create', { variables: { companyId } })
    const formattedPayload = {
        name: payload.name,
        description: payload.description || undefined
    }

    const response = await requestService<Application>(url, {
        method: 'POST',
        data: formattedPayload
    })

    trackEvent('Create_Application')

    return response
}

export const deleteApplicationService = async (
    companyId: Company['id'],
    id: Application['id']
): Promise<RequestResponse<Application> | undefined> => {
    const url = resolveApiUrl('application.delete', { variables: { companyId, id } })
    const response = await requestService<Application>(url, { method: 'DELETE' })

    trackEvent('Delete_Application')

    return response
}
